@if (!embeddedText.CssClasses.includes('marquee-slider')) {
  <div
    [innerHTML]="getRichText() | embed : 'html'"
    class="{{ embeddedText.CssClasses }} DTX_CONTENT_TYPE_TEXT"
    dtxAnimations
  ></div>
}
